import React from "react";

const ArrowRight = ({
  width = 16,
  height = 17,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39605 14.1719C8.25747 14.1719 8.13488 14.1372 8.02829 14.0679C7.92169 13.9985 7.84441 13.9025 7.79644 13.7799C7.74847 13.6572 7.73781 13.5319 7.76446 13.4039C7.79111 13.2759 7.84707 13.1692 7.93235 13.0839L12.8891 8.10787L7.93235 3.14787C7.86839 3.08387 7.82042 3.01187 7.78844 2.93187C7.75646 2.85187 7.74047 2.76921 7.74047 2.68387C7.74047 2.59854 7.75646 2.51854 7.78844 2.44387C7.82042 2.36921 7.86839 2.29987 7.93235 2.23587C7.99631 2.17187 8.06826 2.12387 8.14821 2.09187C8.22816 2.05987 8.30277 2.04387 8.37206 2.04387C8.44135 2.04387 8.52929 2.06521 8.63589 2.10787C8.71051 2.13987 8.7798 2.18787 8.84376 2.25187L14.2482 7.65987C14.3762 7.78787 14.4401 7.93987 14.4401 8.11587C14.4401 8.29187 14.3762 8.44387 14.2482 8.57187L8.84376 13.9799C8.71584 14.1079 8.5666 14.1719 8.39605 14.1719ZM13.8005 8.74787H2.28802C2.10681 8.74787 1.9549 8.68654 1.83232 8.56387C1.70973 8.44121 1.64844 8.29187 1.64844 8.11587C1.64844 7.93987 1.7124 7.78787 1.84031 7.65987C1.96823 7.53187 2.11747 7.46787 2.28802 7.46787H13.8005C13.9711 7.46787 14.1203 7.53187 14.2482 7.65987C14.3762 7.78787 14.4401 7.93987 14.4401 8.11587C14.4401 8.29187 14.3788 8.44121 14.2562 8.56387C14.1336 8.68654 13.9817 8.74787 13.8005 8.74787Z"
        fill="#111828"
      />
    </svg>
  );
};

export default ArrowRight;
